import React from "react";
import {action, observable, computed, makeAutoObservable} from "mobx";

class CommonPopupStore {
    constructor() {
        makeAutoObservable(this);
    }

    @observable
    popupList = new Array<{ key: string|null, element: React.ReactElement }>();

    @action
    public addModal(attrs: React.ReactElement) {
        this.popupList.push({key: attrs.key, element: attrs})
    }

    @action
    public closeLastPopup() {
        if (this.popupList.length > 0) {
            this.popupList.pop();
        }
        // console.log("CommonPopupStore", this.popupList.length);
    }

    deletePopup(attrs: any) {
        const index = this.popupList.findIndex(item => item.key === attrs.key)
        //delete this.popupList[index];
    }
}

export default new CommonPopupStore();